/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Toast_Sent2Inputs */

const en_coinvestments_draftemail_toast_sent2 = /** @type {(inputs: Coinvestments_Draftemail_Toast_Sent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email sent`)
};

/**
* | output |
* | --- |
* | "Email sent" |
*
* @param {Coinvestments_Draftemail_Toast_Sent2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_toast_sent2 = /** @type {((inputs?: Coinvestments_Draftemail_Toast_Sent2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Toast_Sent2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_toast_sent2(inputs)
});
export { coinvestments_draftemail_toast_sent2 as "coInvestments_draftEmail_toast_sent" }